import { StudentComponent } from "../../student/components/student.component";
import { Router, ActivatedRoute } from "@angular/router";
import { Component, OnInit, OnDestroy, AfterViewInit, ApplicationRef, Injector, EventEmitter, Output, ComponentFactoryResolver } from "@angular/core";
import { Subscription } from "rxjs";

import { ClassroomAttendanceService } from "./classroomAttendance.service";

import { HttpclientService } from "../../../shared";
import { ClassAttendanceAddMultiplePBISRequest } from "./point/addPoints/ClassAttendanceAddMultiplePBISRequest";
import { AddPointService } from "./point/addPoints/addPoints.service";
import { ConfirmationService } from "primeng/api";

import * as moment from "moment";

@Component({
	selector: "caass-classroom-classroomAttendance",
	templateUrl: "./classroomAttendance.component.html",
	styleUrls: ["./classroomAttendance.component.css"],
})
export class ClassroomClassroomAttendanceComponent implements OnInit, OnDestroy {
	constructor(
		//private classroomAttendanceService: ClassroomAttendanceService,
		private router: Router,
		private route: ActivatedRoute,
		private applicationRef: ApplicationRef,
		private injector: Injector,
		private componentFactoryResolver: ComponentFactoryResolver,
		private httpclientService: HttpclientService,
		private classroomService: ClassroomAttendanceService,
		private addPointService: AddPointService,
		private confirmationService: ConfirmationService
	) {
		// this.addPointC = false;
		// this.redeemPointC = false;
	}

	ngOnInit() {
		var thisComponent = this;

		this.subscription = this.classroomService.onSectionChange().subscribe((response) => {
			// console.log("Section changed");
			// console.log(response);

			thisComponent.selectedParameters = response;
			this.StudentGetList();
			this.loadScanSound();
		});

		this.cancelEditSubscription = this.classroomService.onCancelEdit().subscribe((response) => {
			this.addPointC = false;
			this.redeemPointC = false;
			this.voidTransactionC = false;
			this.Aexcuse = false;
			this.incidentC = false;
		});
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////////////////

	addPointC: boolean;
	erroMessage = "";
	closeButtonColor = "";
	redeemPointC: boolean;
	voidTransactionC: boolean;
	incidentC: boolean;
	saving = false;
	checkBoxAll = false;
	showClassroomAttendance = false;
	action;
	closeAttendance = false;
	loadingPastRecord = false;
	presentAll = false;
	absentAll = false;
	tardyAll = false;
	showStudentInfo = false;
	submitAll = false;
	pbisAll: boolean = false;
	Aexcuse: boolean;
	checkboxAllShow = false;
	isAddPointAll = false;
	showExcuse = true;
	color: string = "";
	studentList: any = [];
	studentInfoList: any = [];
	pastAttendanceStudentList: any = [];
	originalStudentList: any = [];
	originalPastAttendanceStudentList: any = [];

	checkedStudentList: any = [];
	checkedList: any = [];
	originalcheckedStudentList: any = [];
	checkedAllList: any = [];
	lastSelected;
	hideSharedLinkCopyMessage: boolean;
	PleaseSubmitMessage = false;
	AlreadySavedMessage = false;
	showAttendance = false;
	hideSharedLinkCopyMessage2 = true;
	hideSharedLinkCopyMessage3 = false;
	showButton = false;
	componentRef: any;
	saveErrorMessage: any;
	checkedAll = false;
	selectedAll: any;
	hostView: any;
	pbuttonColor;
	abuttonColor;
	tbuttonColor;
	otherButton;
	scanID;
	sectionScheduleDetailID: any;
	today = new Date();
	p = 0;
	a = 0;
	t = 0;
	displayExcuse: any;
	studentPicture: any;
	display: boolean = false;

	subscription: Subscription;
	cancelEditSubscription: Subscription;

	selectedParameters: any;
	classDate: any;
	isLoading = false;

	SoundData: any;
	audio: any = new Audio();

	ShowGroupAddPoints: boolean = false;
	SchoolID: any;
	AddProcessing: boolean = false;

	/////////////////////////////////////////////////////////////////////////////////////////////

	loadScanSound() {
		var result = this.classroomService.ClassroomGetScanSound(this.selectedParameters.SchoolID);
		result.subscribe(
			(response) => {
				this.SoundData = response[0];
			},
			(error) => {}
		);
	}

	private StudentGetList() {
		this.showAttendance = false;
		var params = this.selectedParameters;
		var a = params.classDate;
		var b = moment(this.today).format("MM/DD/YYYY");
		if (a == b) {
			this.showClassroomAttendance = true;
			this.showAttendance = true;
			this.closeAttendance = false;
			this.isLoading = true;
		} else {
			this.showClassroomAttendance = true;
			this.showAttendance = false;
			this.closeAttendance = true;
			this.loadingPastRecord = true;
		}
		this.addPointC = false;
		this.redeemPointC = false;
		this.voidTransactionC = false;
		this.isAddPointAll = false;
		//this.Aexcuse = false;
		this.incidentC = false;
		this.sectionScheduleDetailID = params.SectionScheduleDetailID;

		if (!params || !params.SectionScheduleDetailID) {
			this.studentList = [];
			this.originalStudentList = [];
			this.checkedStudentList = [];
			this.isLoading = false;
			return;
		}

		this.isLoading = true;
		var result = this.classroomService.StudentGetList(params.SectionScheduleDetailID, moment(params.classDate).format("MM/DD/YYYY"), params.AllSections);
		this.classDate = moment(params.classDate).format("MM/DD/YYYY");

		result.subscribe(
			(response: any) => {
				this.loadingPastRecord = false;
				this.isLoading = false;
				this.studentList = response;

				this.SchoolID = this.studentList[0].SchoolID;

				var originalStudentList = this.originalStudentList;
				var checkedStudentList = this.checkedStudentList;

				$.each(this.studentList, function (index, result) {
					originalStudentList.push({
						PersonID: result.PersonID,
						ClassAttendanceStatusID: result.ClassAttendanceStatusID,
						ClassAttendanceID: result.ClassAttendanceID,
						SectionScheduleDetailID: result.SectionScheduleDetailID,
					});

					checkedStudentList.push({
						PersonID: result.PersonID,
						ClassAttendanceStatusID: result.ClassAttendanceStatusID,
					});

					result.ShowPointsOptions = false;
					result.pbuttonColor = "";
					result.tbuttonColor = "";
					result.abuttonColor = "";
					if (result.ClassAttendanceStatusID == 1) {
						result.pbuttonColor = "green";
					} else if (result.ClassAttendanceStatusID == 5) {
						result.tbuttonColor = "yellow";
					} else {
						result.abuttonColor = "red";
					}
					if (
						!(
							result.ClassAttendanceStatusCD == "P" ||
							result.ClassAttendanceStatusCD == "A" ||
							result.ClassAttendanceStatusCD == "U" ||
							result.ClassAttendanceStatusCD == null
						)
					) {
						result.otherButton = result.ClassAttendanceStatusDesc;
					} else {
						result.otherButton = "Other";
					}

					result.SectionScheduleDetailID = params.SectionScheduleDetailID;
					// this.Aexcuse = false;
					result.Excuse = {
						ClassAttendanceExcuseDesc: "",
						ClassAttendanceExcuseID: 0,
					};
				});
				this.hideSharedLinkCopyMessage2 = false;

				this.attendanceTaken();

				this.showButton = true;
				this.showExcuse = true;
			},
			(error) => {}
		);
	}

	pullStudentInfo(event: any, personID) {
		this.SelectedPersonID = personID;
		this.showStudentInfo = true;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.studentInfoList = student[0];
	}
	offStudentInfo() {
		this.showStudentInfo = false;
		this.studentInfoList = [];
	}
	attendanceTaken() {
		var count = 0;
		for (let i of this.studentList) {
			if (i.ClassAttendanceStudentID.length == 0) {
				count = count + 1;
			}
		}

		if (count == this.studentList.length) {
			this.PleaseSubmitMessage = true;
			this.AlreadySavedMessage = false;
		} else {
			this.AlreadySavedMessage = true;
			this.PleaseSubmitMessage = false;
		}
	}
	doSOmething(selectedExcuse: any, personID) {
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});

		student[0].Excuse = selectedExcuse;

		student[0].displayExcuse = this.displayExcuse;
		student[0].ClassAttendanceExcuseDesc = selectedExcuse.ClassAttendanceExcuseDesc;
		student[0].showExcuse = true;
		//student[0].otherButton = "X";
		this.Aexcuse = false;
	}

	public changeBalancePoint(Point: any, personid): void {
		var student = this.studentList.filter((a) => {
			return a.PersonID == personid;
		});
		student[0].PointsBalance = Point;
	}

	SelectedPersonID: any = 0;

	setpColor(event: any, personID) {
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		var target = event.target || event.srcElement || event.currentTarget;
		var idAttr = target.attributes.id;
		var value = idAttr.nodeValue;

		student[0].ClassAttendanceStatusID = 0;

		//
		// Keep track of late entry time
		//
		var now = new Date();
		student[0].SubmittedDT = moment(now).format("MM/DD/YYYY hh:mm:ss A");
		student[0].EntryTime = moment(now).format("MM/DD/YYYY hh:mm:ss A");

		if (value == "pButton") {
			student[0].ClassAttendanceStatusID = 1;
			student[0].ClassAttendanceStatusCD = "P";
			student[0].ClassAttendanceStatusDesc = "Present for Class";

			this.abuttonColor = "";
			this.tbuttonColor = "";
			this.displayExcuse = "";
			this.otherButton = "Other";
			this.showExcuse = false;
			this.incidentC = false;
			this.pbuttonColor = "green";
		} else if (value == "aButton") {
			student[0].ClassAttendanceStatusID = 2;
			student[0].ClassAttendanceStatusCD = "A";
			student[0].ClassAttendanceStatusDesc = "Absent from Class";
			this.pbuttonColor = "";
			this.tbuttonColor = "";
			this.displayExcuse = "";
			this.incidentC = false;
			this.otherButton = "Other";
			this.showExcuse = false;
			this.abuttonColor = "red";
		} else if (value == "tButton") {
			student[0].ClassAttendanceStatusID = 5;
			student[0].ClassAttendanceStatusCD = "U";
			student[0].ClassAttendanceStatusDesc = "Tardy to Class, Unexcused";
			this.pbuttonColor = "";
			this.abuttonColor = "";
			this.displayExcuse = "";
			this.incidentC = false;
			this.otherButton = "Other";
			this.showExcuse = false;
			this.tbuttonColor = "yellow";
		} else if (value == "oButton") {
			this.pbuttonColor = "";
			this.abuttonColor = "";
			this.tbuttonColor = "";
			this.showExcuse = false;
			this.incidentC = false;
			this.otherButton = "Other";
		}

		student[0].pbuttonColor = this.pbuttonColor;
		student[0].abuttonColor = this.abuttonColor;
		student[0].tbuttonColor = this.tbuttonColor;
		student[0].otherButton = this.otherButton;
		//student[0].otherButton = this.otherButton;
	}

	studentScanned(IdValue) {
		var studentRecord = [];
		this.scanID = this.ReplaceAll(String(IdValue).toLowerCase(), "shift", "");

		var student = this.studentList.filter((a) => {
			return (
				String(a.StudentID).toLowerCase() == String(this.scanID) ||
				String(a.CAASSUID).toLowerCase() == String(this.scanID) ||
				String(a.CaassBarcode).toLowerCase() == String(this.scanID)
			);
		});

		studentRecord = [
			{
				ClassAttendanceID: "",
				ClassAttendanceStatusID: 1,
				ClassAttendanceStatusCD: "P",
				ClassAttendanceStatusDesc: "Present for Class",
				abuttonColor: "",
				tbuttonColor: "",
				displayExcuse: "",
				otherButton: "Other",
				showExcuse: false,
				incidentC: false,
				pbuttonColor: "green",
			},
		];

		//student[0].ClassAttendanceStatusID = 0;

		//
		// Old Version
		//
		// student[0].ClassAttendanceStatusID = 1;
		// student[0].ClassAttendanceStatusCD = "P";
		// student[0].ClassAttendanceStatusDesc = "Present for Class";
		// this.abuttonColor = "";
		// this.tbuttonColor = "";
		// this.displayExcuse = "";
		// this.otherButton = "Other";
		// this.showExcuse = false;
		// this.incidentC = false;
		// this.pbuttonColor = "green";
		// student[0].pbuttonColor = this.pbuttonColor;
		// student[0].abuttonColor = this.abuttonColor;
		// student[0].tbuttonColor = this.tbuttonColor;
		// student[0].otherButton = this.otherButton;

		//
		// 10.9
		// Get status based on time
		//

		// console.log("Parameters");
		// console.log(this.selectedParameters);

		// console.log("Start Time");
		// console.log(this.selectedParameters.StartTime);

		// console.log("Start Time Date");
		// console.log(new Date(this.selectedParameters.StartTime));

		// console.log("Start Time Date 2");
		// console.log(
		//  new Date(
		//    moment(new Date()).format("MM/DD/YYYY") +
		//    " " +
		//    moment(new Date(this.selectedParameters.StartTime)).format("HH:mm:ss")
		//  )
		// );

		var now = new Date();
		var nowRounded = new Date(moment(now).format("MM/DD/YYYY HH:mm")); //Round down to nearest minute

		student[0].SubmittedDT = moment(now).format("MM/DD/YYYY hh:mm:ss A");
		student[0].EntryTime = moment(now).format("MM/DD/YYYY hh:mm:ss A");

		var PeriodStartTime = new Date(
			moment(new Date()).format("MM/DD/YYYY") +
				" " +
				// moment(new Date(this.selectedParameters.StartTime)).format("HH:mm:ss")
				moment(new Date(this.selectedParameters.StartTime)).format("HH:mm")
		);

		// console.log("Now");
		// console.log(now);
		// console.log("Now Rounded");
		// console.log(nowRounded);
		// console.log("Start Time");
		// console.log(PeriodStartTime);

		//
		// Student Late to class
		//
		if (PeriodStartTime < nowRounded) {
			// console.log("Student Late to class");

			student[0].ClassAttendanceStatusID = 5; //Tardy no excuse
			student[0].ClassAttendanceStatusCD = "U";
			student[0].ClassAttendanceStatusDesc = "Tardy to Class, Unexcused";
			this.pbuttonColor = "";
			this.abuttonColor = "";
			this.tbuttonColor = "yellow";
			this.displayExcuse = "";
			this.otherButton = "Other";
			this.showExcuse = false;
			this.incidentC = false;
			student[0].pbuttonColor = this.pbuttonColor;
			student[0].abuttonColor = this.abuttonColor;
			student[0].tbuttonColor = this.tbuttonColor;
			student[0].otherButton = this.otherButton;
		}
		//
		// Student on time
		//
		else {
			// console.log("Student on time");

			student[0].ClassAttendanceStatusID = 1;
			student[0].ClassAttendanceStatusCD = "P";
			student[0].ClassAttendanceStatusDesc = "Present for Class";
			this.abuttonColor = "";
			this.tbuttonColor = "";
			this.displayExcuse = "";
			this.otherButton = "Other";
			this.showExcuse = false;
			this.incidentC = false;
			this.pbuttonColor = "green";
			student[0].pbuttonColor = this.pbuttonColor;
			student[0].abuttonColor = this.abuttonColor;
			student[0].tbuttonColor = this.tbuttonColor;
			student[0].otherButton = this.otherButton;
		}

		this.scanID = "";

		//
		//Play sound when students scan in
		//

		// console.log("Sound Data");
		// console.log(this.SoundData);

		//Get base64 Data
		var base64 = this.SoundData.SoundData;

		this.audio = new Audio("data:audio/mp3;base64," + base64);
		this.audio.play();
	}

	ReplaceAll(OriginalString: string, ToFind: string, ReplaceWith: string) {
		// Go through all instances
		while (OriginalString.indexOf(ToFind) != -1) {
			OriginalString = OriginalString.replace(ToFind, ReplaceWith);
		}

		return OriginalString;
	}

	AbExcuse(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.voidTransactionC = false;
		this.Aexcuse = true;
		student[0].Aexcuse = this.Aexcuse;
		this.showExcuse = true;
		student[0].otherButton = "X";
		student[0].ClassAttendanceStatusID = 6;
		student[0].ClassAttendanceStatusCD = "X";
		student[0].ClassAttendanceStatusDesc = "Absent, Excused";
		student[0].SubmittedDT = moment(new Date()).format("MM/DD/YYYY hh:mm A");
	}
	ClassCut(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.voidTransactionC = false;
		this.Aexcuse = false;
		this.showExcuse = false;
		//student[0].Aexcuse = this.Aexcuse;
		student[0].otherButton = "C";
		student[0].ClassAttendanceStatusID = 3;
		student[0].ClassAttendanceStatusCD = "C";
		student[0].ClassAttendanceStatusDesc = "Class Cut";
		student[0].SubmittedDT = moment(new Date()).format("MM/DD/YYYY hh:mm A");
	}

	LExcuse(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.voidTransactionC = false;
		this.Aexcuse = true;
		this.showExcuse = true;
		student[0].Aexcuse = this.Aexcuse;
		student[0].otherButton = "Y";
		student[0].ClassAttendanceStatusID = 7;
		student[0].ClassAttendanceStatusCD = "Y";
		student[0].ClassAttendanceStatusDesc = "Left Early, Excused";
		student[0].SubmittedDT = moment(new Date()).format("MM/DD/YYYY hh:mm A");
	}
	LUnexcuse(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.voidTransactionC = false;
		this.Aexcuse = false;
		this.showExcuse = false;
		// student[0].Aexcuse = this.Aexcuse;
		student[0].otherButton = "L";
		student[0].ClassAttendanceStatusID = 8;
		student[0].ClassAttendanceStatusCD = "L";
		student[0].ClassAttendanceStatusDesc = "Left Early, Unexcused";
		student[0].SubmittedDT = moment(new Date()).format("MM/DD/YYYY hh:mm A");
	}

	TExcuse(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.voidTransactionC = false;
		this.Aexcuse = true;
		this.showExcuse = true;
		student[0].Aexcuse = this.Aexcuse;

		student[0].otherButton = "E";
		student[0].ClassAttendanceStatusID = 4;
		student[0].ClassAttendanceStatusCD = "E";
		student[0].ClassAttendanceStatusDesc = "Tardy to Class, Excused";
		student[0].SubmittedDT = moment(new Date()).format("MM/DD/YYYY hh:mm A");
	}

	addPoints(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});

		this.voidTransactionC = false;
		this.redeemPointC = false;
		this.Aexcuse = false;
		this.addPointC = true;
		this.incidentC = false;
		student[0].addPointC = this.addPointC;

		student[0].ShowPointsOptions = false;
	}

	redeemPoints(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.voidTransactionC = false;
		this.addPointC = false;
		this.Aexcuse = false;
		this.incidentC = false;
		this.redeemPointC = true;
		student[0].redeemPointC = this.redeemPointC;

		student[0].ShowPointsOptions = false;
	}

	voidTransaction(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.Aexcuse = false;
		this.incidentC = false;
		this.voidTransactionC = true;
		student[0].voidTransactionC = this.voidTransactionC;

		student[0].ShowPointsOptions = false;
	}

	studentPhotoGet(params) {
		var result = this.classroomService.studentPhotoGet(params.PersonID);
		result.subscribe(
			(response: any) => {
				if (response) {
					this.studentPicture = "data:image/jpg;base64," + response;
				} else {
					this.studentPicture = "assets/images/nophotoavailable.jpg";
					//assets/images/CAASS_LOGO_NEW.png
				}
				//alert(this.studentPicture);
			},
			(error) => {}
		);
	}
	FadeOutLink() {
		setTimeout(() => {
			this.hideSharedLinkCopyMessage = false;
			if (!this.hideSharedLinkCopyMessage) {
				this.AlreadySavedMessage = true;
			}
		}, 9000);
	}

	onSubmitClick() {
		var lstUpdatedList = [];
		this.hideSharedLinkCopyMessage = false;
		this.saving = true;
		var originalStudentList = this.originalStudentList;
		$.each(this.studentList, function (index, result) {
			var originalStudent = originalStudentList.filter((a) => {
				return a.PersonID == result.PersonID;
			});
			if (result.Excuse.ClassAttendanceExcuseID > 0 || result.ClassAttendanceStatusID != originalStudent[0].ClassAttendanceStatusID) {
				lstUpdatedList.push(result);
			} else if (
				result.ClassAttendanceStatusID == originalStudent[0].ClassAttendanceStatusID &&
				result.ClassAttendanceID.length < 1 &&
				(result.ClassAttendanceStatusID == 1 ||
					result.ClassAttendanceStatusID == 2 ||
					result.ClassAttendanceStatusID == 3 ||
					result.ClassAttendanceStatusID == 4 ||
					result.ClassAttendanceStatusID == 5 ||
					result.ClassAttendanceStatusID == 6 ||
					result.ClassAttendanceStatusID == 7 ||
					result.ClassAttendanceStatusID == 8)
			) {
				lstUpdatedList.push(result);
			} else if (result.ClassAttendanceStatusID == originalStudent[0].ClassAttendanceStatusID) {
				lstUpdatedList.push(result);
			}
		});

		// console.log("Modifying Class Attendance");
		// console.log("Updated List");
		// console.log(lstUpdatedList);

		var result = this.classroomService.ClassAttendanceModify(lstUpdatedList, this.classDate);

		result.subscribe(
			(response: any) => {
				this.saving = false;
				this.attendanceTaken();
				this.erroMessage = "";
				this.AlreadySavedMessage = true;
				this.PleaseSubmitMessage = false;
				this.hideSharedLinkCopyMessage = true;

				this.FadeOutLink();

				//this.StudentGetList();
				// alert(this.studentPicture);

				this.classroomService.SaveAttendanceCompleted();
			},
			(error) => {
				this.erroMessage = "Error Occured, Please contact support";
			}
		);
	}

	IncidentbtnClick(event: any, personID) {
		this.SelectedPersonID = personID;
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		this.redeemPointC = false;
		this.addPointC = false;
		this.Aexcuse = false;
		this.voidTransactionC = false;
		this.incidentC = true;
		student[0].incidentC = this.incidentC;
	}
	selectAll() {
		this.checkedAllList = [];

		for (var i = 0; i < this.studentList.length; i++) {
			this.studentList[i].selected = this.selectedAll;
			this.checkedAllList.push(this.studentList[i].PersonID);
		}

		this.checkedAll = true;
	}

	onCheckboxChange(personID, event: any) {
		var student = this.studentList.filter((a) => {
			return a.PersonID == personID;
		});
		if (event.target.checked) {
			this.checkedList.push(personID);
		} else {
			for (var i = 0; i < this.checkedStudentList.length; i++) {
				if (this.checkedList[i] == personID) {
					this.checkedList.splice(i, 1);
				}
			}
		}
	}

	selectecStudentGetList() {
		var checked = [];
		if (this.checkedList.length > 0) {
			checked = this.checkedList;
		} else if (this.checkedAllList.length > 0) {
			checked = this.checkedAllList;
		} else {
			return;
		}
		var lstUpdatedList = this.studentList.filter((a) => {
			var index = $.inArray(a.PersonID, checked);
			if (index >= 0) {
				return true;
			} else {
				return;
			}
		});
		return lstUpdatedList;
	}

	oncheckedSubmitClick(ClassAttendanceStatusID) {
		this.hideSharedLinkCopyMessage = false;
		var lstUpdatedList = this.selectecStudentGetList();
		if (!lstUpdatedList) {
			this.erroMessage = "Please select Students";
			return;
		} else {
			this.saving = true;

			$.each(lstUpdatedList, function (index, result) {
				//
				// Entry Time
				//

				var now = new Date();
				result.SubmittedDT = moment(now).format("MM/DD/YYYY hh:mm:ss A");
				result.EntryTime = moment(now).format("MM/DD/YYYY hh:mm:ss A");

				result.ClassAttendanceStatusID = ClassAttendanceStatusID;

				if (ClassAttendanceStatusID == 1) {
					result.ClassAttendanceStatusCD = "P";
					result.ClassAttendanceStatusDesc = "Present for Class";
				} else if (ClassAttendanceStatusID == 2) {
					result.ClassAttendanceStatusCD = "A";
					result.ClassAttendanceStatusDesc = "Absent from Class";
				} else if (ClassAttendanceStatusID == 5) {
					result.ClassAttendanceStatusCD = "U";
					result.ClassAttendanceStatusDesc = "Tardy to Class, Unexcused";
				}
			});

			var result = this.classroomService.ClassAttendanceModify(lstUpdatedList, this.classDate);

			result.subscribe(
				(response: any) => {
					this.saving = false;
					this.erroMessage = "";

					this.checkedList = [];
					this.checkedAllList = [];

					this.hideSharedLinkCopyMessage = true;
					this.FadeOutLink();
					this.classroomService.LoadData();
				},
				(error) => {
					this.erroMessage = "Error Occured, Please contact support..";
					this.saving = false;
				}
			);
		}
	}
	onhover(action) {
		if (action == 1) {
			this.checkboxAllShow = true;
		} else if (action == 2) {
			this.presentAll = true;
		} else if (action == 3) {
			this.absentAll = true;
		} else if (action == 4) {
			this.tardyAll = true;
		} else if (action == 5) {
			this.submitAll = true;
		} else if (action == 6) {
			this.closeButtonColor = "red";
		} else if (action == 7) {
			this.pbisAll = true;
		}
	}
	nohover(action) {
		if (action == 1) {
			this.checkboxAllShow = false;
		} else if (action == 2) {
			this.presentAll = false;
		} else if (action == 3) {
			this.absentAll = false;
		} else if (action == 4) {
			this.tardyAll = false;
		} else if (action == 5) {
			this.submitAll = false;
		} else if (action == 6) {
			this.closeButtonColor = "";
		} else if (action == 7) {
			this.pbisAll = false;
		}
	}
	onAddSubmitClick() {
		var selectedStudentList = this.selectecStudentGetList();
		if (!selectedStudentList || selectedStudentList.length == 0) {
			return;
		}

		this.isAddPointAll = true;
	}
	removePastRecord() {
		this.closeAttendance = false;
		this.showClassroomAttendance = false;
	}
	removeTodayattendance() {
		this.showAttendance = false;
		this.showClassroomAttendance = false;
	}

	onAddPointsAllClick() {
		this.erroMessage = "";
		this.ShowGroupAddPoints = true;
	}

	AddGroupPoints(PointsItemID) {
		this.erroMessage = "";

		//
		// Create Parms
		//
		var lstSelected = this.selectecStudentGetList();

		if (lstSelected == undefined) {
			this.erroMessage = "Select Students to add points to (Click the checkboxes)";
			return;
		}

		this.AddProcessing = true;

		var lstPIDs: number[] = [];

		for (var z = 0; z < lstSelected.length; z++) {
			var next = lstSelected[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: ClassAttendanceAddMultiplePBISRequest = {
			PointsItemID: PointsItemID,
			lstPersonIDs: lstPIDs,
		};

		//
		// Make WS Call
		//
		var result = this.addPointService.ClassAttendanceAddMultiplePBIS(parms);
		result.subscribe(
			(response: any) => {
				this.AddProcessing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "classattendance",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "PBIS Points were added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ShowGroupAddPoints = false;
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "classattendance",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add PBIS points.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.AddProcessing = false;
			}
		);
	}

	CancelGroupPoints() {
		this.erroMessage = "";
		this.ShowGroupAddPoints = false;
	}

	onDropdownOpen(student) {
		//
		// When opening a dropdown, close all the others
		// (Checking for false because it hasn't been toggled yet)
		//
		if (student.ShowPointsOptions == false) {
			for (var z = 0; z < this.studentList.length; z++) {
				var next = this.studentList[z];

				next.ShowPointsOptions = false;
			}

			for (var z = 0; z < this.studentInfoList.length; z++) {
				var next = this.studentInfoList[z];

				next.ShowPointsOptions = false;
			}

			for (var z = 0; z < this.originalStudentList.length; z++) {
				var next = this.originalStudentList[z];

				next.ShowPointsOptions = false;
			}

			for (var z = 0; z < this.checkedStudentList.length; z++) {
				var next = this.checkedStudentList[z];

				next.ShowPointsOptions = false;
			}

			this.incidentC = false;
			this.addPointC = false;
			this.redeemPointC = false;
			this.voidTransactionC = false;
		}

		student.ShowPointsOptions = !student.ShowPointsOptions;
	}
}
